// Сборник примеров генерации элементов (PlantUML + JS)
// Можно расширять по мере появления новых кейсов.

export const CODE_SAMPLES = {
  plantUmlSequence: `@startuml
participant GATEWAY as "API Gateway"
participant BILLING_GATEWAY as "Billing Gateway"
participant BILLING_SVC as "Billing Service"
database BILLING_DB as "Billing DB"

GATEWAY -> BILLING_GATEWAY: Payment Request
alt Success
  BILLING_GATEWAY -> BILLING_SVC: Process Payment
  BILLING_SVC -> BILLING_DB: Store Transaction
  BILLING_DB --> BILLING_SVC: Confirmed
else Failure
  BILLING_GATEWAY --> GATEWAY: Error
end
BILLING_SVC --> BILLING_GATEWAY: Payment OK
BILLING_GATEWAY --> GATEWAY: Response
@enduml`,

  structurizrC4: `workspace "Atlas" {
  model {
    user = person "User" "Works with the architecture workspace"
    atlas = softwareSystem "Aspect" "Atlas architecture workspace" {
      discovery = container "Discovery Service" "Discovers Kubernetes infrastructure" "Go"
      registry = container "Meta Repository Service" "Stores architecture registry and diagrams" "Go"
      db = container "Atlas DB" "Stores architecture metadata" "PostgreSQL" {
        tags "Database"
      }
    }

    user -> atlas "Uses"
    discovery -> db "Stores discovered resources" "PostgreSQL"
    registry -> db "Reads and writes registry data" "PostgreSQL"
  }
  views {
    systemContext atlas {
      include *
    }
    container atlas {
      include *
    }
  }
}`,

  simple: `// Простая схема
const r1 = ElementFactory.rectangle(100, 100, 140, 80);
const c1 = ElementFactory.circle(320, 140, 40);
const a1 = ElementFactory.arrow(220, 140, 320, 140); // концы будут примагничены
const t1 = Helpers.textInside(r1, 'Node');
return [r1, c1, a1, t1];`,

  architecture: `// Архитектурная диаграмма
const r1 = ElementFactory.rectangle(50, 200, 120, 70);
const r2 = ElementFactory.rectangle(220, 150, 140, 90);
const r3 = ElementFactory.rectangle(410, 100, 120, 70);
const c1 = ElementFactory.circle(220, 50, 35);
const t1 = Helpers.textInside(r1, 'DB');
const t2 = Helpers.textInside(r2, 'API');
const t3 = Helpers.textInside(r3, 'FE');
const t4 = Helpers.textInside(c1, 'Cache');
const a1 = Helpers.arrowBetween(r1, r2);
const a2 = Helpers.arrowBetween(r2, r3);
const a3 = Helpers.arrowBetween(r2, c1);
return [r1, r2, r3, c1, t1, t2, t3, t4, a1, a2, a3];`,

  workflow: `// Workflow диаграмма
const start = ElementFactory.circle(100, 100, 30);
const p1 = ElementFactory.rectangle(200, 80, 120, 60);
const p2 = ElementFactory.rectangle(200, 180, 120, 60);
const end = ElementFactory.circle(420, 130, 30);
const tStart = Helpers.textInside(start, 'Start');
const tP1 = Helpers.textInside(p1, 'Step 1');
const tP2 = Helpers.textInside(p2, 'Step 2');
const tEnd = Helpers.textInside(end, 'End');
const a1 = Helpers.arrowBetween(start, p1);
const a2 = Helpers.arrowBetween(p1, p2);
const a3 = Helpers.arrowBetween(p2, end);
return [start, p1, p2, end, tStart, tP1, tP2, tEnd, a1, a2, a3];`,

  erdDefault: `@startuml
class Order {
  -id: int
  +status: String
  +total(): float
}

class Customer {
  -name: String
  -email: String
}

class Product {
  +name: String
  +price: float
}

Order --> Customer : placed by
Order *-- Product : contains
@enduml`,

  freeDsl: `@startfree
actor User
rectangle "API Gateway"
database DB

User -> "API Gateway" : запрос
"API Gateway" --> DB : query
DB ..> "API Gateway" : rows
@endfree`,
};

// Метаданные для выпадающего списка (id -> label)
export const CODE_SAMPLE_LIST = [
  { id: 'plantUmlSequence', label: 'Диаграмма последовательностей (PlantUML)' },
  { id: 'simple', label: 'Простая схема' },
  { id: 'architecture', label: 'Архитектурная диаграмма' },
  { id: 'workflow', label: 'Workflow схема' }
];
